const tabList = () => {
  const containers = document.querySelectorAll('.js-tab-list');
  for (let i = 0; i < containers.length; i++) {
    const container = containers[i];
    const tabs = container.querySelectorAll('a');
    for (let j = 0; j < tabs.length; j++) {
      const tab = tabs[j];
      tab.addEventListener('click', function(e) {
        e.preventDefault();
        for (let k = 0; k < tabs.length; k++) {
          tabs[k].setAttribute('aria-selected', 'false');
          const panel = document.getElementById(tabs[k].getAttribute('aria-controls'));
          if (panel) {
            panel.setAttribute('aria-hidden', 'true');
          }
        }
        const elsControllingThisTab = container.querySelectorAll(`[aria-controls="${e.currentTarget.getAttribute('aria-controls')}"]`);
        for (let l = 0; l < elsControllingThisTab.length; l++) {
          elsControllingThisTab[l].setAttribute('aria-selected', 'true');
        }
        const panel = document.getElementById(e.currentTarget.getAttribute('aria-controls'));
        if (panel) {
          panel.setAttribute('aria-hidden', 'false');
          // scroll at top of the html doc
          setTimeout(() => {
            // if more than 30px from top, scroll to top
            if (window.scrollY > 30) {
              window.scrollTo(0, 0);
            }
          }, 100);

        }
      });
    }
  }
};

const independentTabLinks = () => {
  const links = document.querySelectorAll('.js-indepentend-tab-link');
  for (let i = 0; i < links.length; i++) {
    const link     = links[i];
    const controls = link.getAttribute('aria-controls');
    const tabListLinks = document.querySelectorAll(`.js-tab-list-item[aria-controls="${controls}"]`);
    for (let j = 0; j < tabListLinks.length; j++) {
      const tabListLink = tabListLinks[j];
      link.addEventListener('click', function(e) {
        e.preventDefault();
        tabListLink.click();
      });
    }
  }

};

tabList();
independentTabLinks();
